export const SET_SCREEN_DIMENSIONS = 'SET_SCREEN_DIMENSIONS';
export const SET_IS_IPAD = 'SET_IS_IPAD';
export const SET_HASWEBGL = 'SET_HASWEBGL';
export const SET_ORIENTATION = 'SET_ORIENTATION';
export const SET_ISMOBILE = 'SET_ISMOBILE';
export const SET_ISCREENWIDTHSMALL = 'SET_ISCREENWIDTHSMALL';

export const setIsMobile = payload => ({
  type: SET_ISMOBILE,
  payload
});

export const setIsScreenWidthSmall = payload => ({
  type: SET_ISCREENWIDTHSMALL,
  payload
});

export const setOrientation = payload => ({
  type: SET_ORIENTATION,
  payload
});

export const setScreenDimensions = payload => ({
  type: SET_SCREEN_DIMENSIONS,
  payload
});

export const setIsIPad = payload => ({
  type: SET_IS_IPAD,
  payload
});

export const setHasWebGL = payload => ({
  type: SET_HASWEBGL,
  payload
});

export default setIsMobile;
